/**
 * @license
 * @preserve
 *
 * MIT License
 * 
 * Copyright (c) 2022 KeeeX SAS
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * 
 * ----------------------------------------
 * 
 * ISC License from bitcoinjs/bip39 project and source
 * 
 * Copyright (c) 2014, Wei Lu <luwei.here@gmail.com> and Daniel Cousens <email@dcousens.com>
 * 
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 * 
 */
export const normalizeUTF8String = (str) => str.normalize("NFKD");
const BINARY_BASE = 2;
const BYTE_CHR_LENGTH = 8;
export const binaryToByte = (bin) => parseInt(bin, BINARY_BASE);
export const bytesToBinary = (bytes) => bytes.map(x => x.toString(BINARY_BASE).padStart(BYTE_CHR_LENGTH, "0")).join("");
const WORD_BIT_LENGTH = 11;
/** Convert a number to its binary representation with 11 bits */
export const numberToBinary11 = (value) => value.toString(BINARY_BASE)
    .padStart(WORD_BIT_LENGTH, "0");
const BIT_PER_BYTE = 8;
export const byteLengthToBitLength = (byteLength) => byteLength * BIT_PER_BYTE;
export const containIdeograms = (input) => {
    const IDEOGRAM_START = 0x3000;
    const IDEOGRAM_END = 0x3100;
    for (let index = 0; index < input.length; ++index) {
        const chr = input.charCodeAt(index);
        if (chr >= IDEOGRAM_START && chr <= IDEOGRAM_END)
            return true;
    }
    return false;
};
